<script setup lang="ts">
/** Ligne de réglage de la modale Affichage : libellé à gauche, contrôle à droite. */
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <div class="display-option-row">
    <div class="d-flex flex-column">
      <span class="display-option-title">{{ title }}</span>
      <span v-if="description" class="display-option-desc">{{
        description
      }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.display-option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 44px;
  padding: 6px 8px;
  border-radius: 8px;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  & + & {
    margin-top: 6px;
  }
}

.display-option-title {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.88);
}

.display-option-desc {
  margin-top: 1px;
  font-size: 11px;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.45);
}
</style>
